/**
 * PromptCard 字段预设词库（中文）
 * 所有字段均为单选：点击 chip → 替换 textarea 全文，后续可自由编辑
 */

export type PresetKey = 'composition' | 'lighting' | 'color' | 'medium' | 'style' | 'mood' | 'quality'

export const PROMPT_PRESETS: Record<PresetKey, string[]> = {
  composition: [
    '极特写',
    '特写',
    '中近景',
    '中景',
    '全景',
    '远景',
    '对称构图',
    '三分法',
    '中央构图',
    '留白',
    '平视',
    '俯视',
    '仰视',
    '鸟瞰',
  ],
  lighting: [
    '黄金时刻',
    '蓝调时刻',
    '正午顶光',
    '阴天柔光',
    '窗边光',
    '侧逆光',
    '顺光',
    '戏剧光',
    '伦勃朗光',
    '体积光',
    '边缘光',
    '霓虹光',
    '烛光',
    '月光',
  ],
  color: [
    '暖色调',
    '冷色调',
    '单色黑白',
    '高对比',
    '莫兰迪色系',
    '马卡龙',
    '复古胶片色',
    '赛博朋克霓虹',
    '暖橘+靛蓝',
    '互补色',
  ],
  medium: [
    '胶片摄影',
    '数字摄影',
    '黑白胶片',
    '3D 渲染',
    '油画',
    '水彩',
    '水墨',
    '速写',
    '像素画',
    '矢量插画',
    '等距插画',
    '漫画',
  ],
  style: [
    '赛博朋克',
    '蒸汽朋克',
    '极简',
    '包豪斯',
    '浮世绘',
    '印象派',
    '超现实',
    '国家地理',
    '电影海报',
    '复古 80 年代',
    '王家卫电影感',
    '新海诚',
  ],
  mood: ['安静', '沉思', '怀旧', '浪漫', '孤独', '欢快', '史诗', '神秘', '紧张', '戏剧'],
  quality: ['8K', '4K', '超清细节', 'RAW', 'HDR', '写实', '杰作', '锐利对焦'],
}
